export default {
    name: 'B0',
    lineHeight: '40px',
    lineHeightDesktop: '60px',
  }